import { ModuleName, RolesName } from "../Pages/Roles/Roles.type";

export const countryList = [
  { value: "1", label: "USA" },
  { value: "2", label: "UK" },
  { value: "3", label: "UAE" },
  { value: "4", label: "SA" },
];

export const stateList = [
  { value: "1", label: "AL" },
  { value: "2", label: "AK" },
  { value: "3", label: "AZ" },
  { value: "4", label: "AR" },
  { value: "5", label: "CA" },
  { value: "6", label: "CO" },
  { value: "7", label: "CT" },
  { value: "8", label: "DE" },
  { value: "9", label: "DC" },
  { value: "10", label: "FL" },
];

export const zipList = [
  { value: "1", label: "585785" },
  { value: "2", label: "789456" },
  { value: "3", label: "894562" },
];

export const clientWarehouseList = [
  { label: "Florida", value: "Florida" },
  { label: "Chicago", value: "Chicago" },
  { label: "CargoCraft", value: "CargoCraft" },
  { label: "OptiStore", value: "OptiStore" },
  { label: "EliteGoods", value: "EliteGoods" },
  { label: "FlexiSpace", value: "FlexiSpace" },
  { label: "Store Hub", value: "Store Hub" },
  { label: "SmartStore", value: "SmartStore" },
];

export const inboundOutboundList = [
  {
    category: "Inbound",
    key: "Inbound return order",
  },
  {
    category: "Inbound",
    key: "Return order with one Step",
  },
  {
    category: "Inbound",
    key: "Inbound one Step",
  },
  {
    category: "Outbound",
    key: "Single order with audit",
  },
  {
    category: "Outbound",
    key: "Multi shipment without audit",
  },
  {
    category: "Outbound",
    key: "Single order with Package assignment",
  },
];

export const accessorialBillCodeList = [
  { label: "Bill Code", value: " ", desc: "Description", isDisabled: true },
  { label: "11042022", value: "11042022", desc: "Pre Order Charge" },
  { label: "20221104", value: "20221104", desc: "Pre Receipt Charge" },
  { label: "20221105", value: "320221105", desc: "Test 2" },
  { label: "20221106", value: "20221106", desc: "Test 3" },
  { label: "20221109", value: "20221109", desc: "Test 4" },
];

export const accessorialSeleteTypleList = [
  { label: "Automatic Billing", value: "Automatic Billing" },
  { label: "Automatic Billing by Date", value: "Automatic Billing by Date" },
  { label: "Bill Price * Quantity", value: "Bill Price * Quantity" },
  { label: "Fixed Price", value: "Fixed Price" },
  { label: "Storage Billing", value: "Storage Billing" },
];

export const accessorialCalcTypleList = [
  { label: "Daily", value: "Daily" },
  { label: "Weekly", value: "Weekly" },
  { label: "Monthly", value: "Monthly" },
  { label: "Fixed Price", value: "Fixed Price" },
];

export const inboundEntityList = [
  { value: "1", label: "ASN 's" },
  { value: "2", label: "Check In" },
  { value: "3", label: "Unload" },
  { value: "4", label: "Receive" },
  { value: "5", label: "Put away" },
];

export const inboundGoalTypeList = [
  { value: "1", label: "No. of Lines" },
  { value: "2", label: "No. of ASN Completed" },
];

export const inboundIntervalList = [
  { value: "1", label: "Per Day" },
  { value: "2", label: "Per Hour" },
];

export const measurementList = [
  { label: "mm", value: "mm" },
  { label: "Inch", value: "Inch" },
  { label: "cm", value: "cm" },
  { label: "ft", value: "ft" },
  { label: "sq", value: "sq" },
];

export const itemsAssemblyTypeList = [
  { value: "1", label: "Assembly" },
  { value: "2", label: "Component" },
];

export const itemsProductAttribute = [
  { value: "2", label: "Tag #" },
  { value: "3", label: "Lot #" },
];

export const itemsFullLife = [];

export const itemsSelfLife = [];

export const itemsShipLife = [];

export const itemsItemPopularity = [
  { value: "1", label: "High Velocity (A)" },
  { value: "2", label: "Medium Velocity (B)" },
  { value: "3", label: "Low Velocity (C)" },
];

export const itemsAllocationMethod = [
  { value: "1", label: "FEFO" },
  { value: "2", label: "LEFO" },
  { value: "3", label: "FIFO" },
  { value: "4", label: "LIFO" },
];

export const itemsCountryOfOrigin = [{ value: "1", label: "US" }];

export const itemsLifeUnit = [
  { value: "1", label: "Days" },
  { value: "2", label: "Month" },
  { value: "2", label: "Year" },
];

export const itemsHtsCode = [{ value: "1", label: "312" }];

export const itemsItemCategory = [];
export const itemsItemGroup = [
  { value: "1", label: "Group A" },
  { value: "2", label: "Group B" },
  { value: "3", label: "Group C" },
];

export const itemsManufacturer = [
  { value: "1", label: "Motorola" },
  { value: "2", label: "Iphone" },
  { value: "3", label: "Samsung" },
];

export const unitUomList = [
  { value: "1", label: "Each - EA" },
  { value: "2", label: "Cases - CA" },
  { value: "3", label: "Pallet - PLT" },
];

export const widthUnit = [
  { value: "1", label: "KG" },
  { value: "2", label: "Litters" },
  { value: "3", label: "gm" },
];

export const selectUomLevel2 = [
  { value: "1", label: "Carton - CR" },
  { value: "2", label: "Drum - DR" },
  { value: "3", label: "Cubic Feet - CR" },
  { value: "4", label: "Pallet - PLT" },
  { value: "5", label: "Cases - CA" },
];

export const selectUomLevel3 = [
  { value: "1", label: "Carton - CR" },
  { value: "2", label: "Drum - DR" },
  { value: "3", label: "Cubic Feet - CR" },
  { value: "4", label: "Pallet - PLT" },
  { value: "5", label: "Cases - CA" },
];

export const selectUomLevel4 = [
  { value: "1", label: "Carton - CR" },
  { value: "2", label: "Drum - DR" },
  { value: "3", label: "Cubic Feet - CR" },
  { value: "4", label: "Pallet - PLT" },
  { value: "5", label: "Cases - CA" },
];

export const itemsDataDescList = [
  { value: "1", label: "Data Received" },
  { value: "2", label: "Scan Data" },
  { value: "3", label: "Manual Data" },
];
export const itemsItemCategoryList = [{ value: "1", label: "Gaming" }];
export const itemsDefaultZoneListList = [
  { value: "1", label: "Zone 1" },
  { value: "2", label: "Zone 2" },
  { value: "3", label: "Zone 3" },
  { value: "4", label: "Zone 4" },
];

export const companyAccountAddressTimeZone = [
  { value: "1", label: "UTC-10 HST (Hawaii Standard Time)" },
  { value: "2", label: "UTC-10 AKST (Alaska Standard Time)" },
  { value: "3", label: "UTC-10 PST (Pacific Standard Time)" },
  { value: "4", label: "UTC-10 MST (Mountain Standard Time)" },
];

export const companyAccountAddressState = [
  { value: "1", label: "Arizona" },
  { value: "2", label: "testState2" },
  { value: "3", label: "testState3" },
  { value: "4", label: "testState4" },
];

export const companyAccountAddressZipCode = [
  { value: "1", label: "85002" },
  { value: "2", label: "testZip2" },
  { value: "3", label: "testZip3" },
  { value: "4", label: "testZip4" },
];

export const companyAccountAddressCountry = [
  { value: "1", label: "US" },
  { value: "2", label: "testCountry2" },
  { value: "3", label: "testCountry3" },
  { value: "4", label: "testCountry4" },
];
export const companyAccountTypeList = [
  { value: "1", label: "Sandbox" },
  { value: "2", label: "Production" },
  { value: "3", label: "Development" },
];
export const companyAccountSourcesList = [
  { value: "1", label: "Face Cin FAES 1.1 Clean Environment(FAES-CLN)" },
  { value: "2", label: "esspl. ESSPL" },
  { value: "3", label: "dhx-s DHX-s" },
];

export const moduleList: ModuleName[] = [
  { value: "1", label: "All" },
  { value: "2", label: "Inbound" },
  { value: "3", label: "Outbound" },
  { value: "4", label: "Inventory" },
  { value: "5", label: "Account Setting" },
];

export class Role {
  public moduleId: string;
  public value: string;
  public label: string;
  constructor() {
    this.moduleId = "";
    this.value = "";
    this.label = "";
  }
}
export const roleNameList: RolesName[] = [
  { value: "1", label: "Admin", moduleId: "2" },
  { value: "2", label: "Customer Service", moduleId: "2" },
  { value: "3", label: "Warehouse Manager", moduleId: "2" },
  { value: "4", label: "Inbound Manager", moduleId: "2" },
  { value: "5", label: "Inbound Supervisor", moduleId: "2" },
  { value: "6", label: "Receiver", moduleId: "2" },
  { value: "7", label: "Auditor", moduleId: "2" },

  { value: "8", label: "Admin", moduleId: "3" },
  { value: "9", label: "Customer Service", moduleId: "3" },
  { value: "10", label: "Warehouse Manager", moduleId: "3" },
  { value: "11", label: "Outbound Manager", moduleId: "3" },
  { value: "12", label: "Outbound Supervisor", moduleId: "3" },
  { value: "13", label: "Picker", moduleId: "3" },
  { value: "14", label: "Packer", moduleId: "3" },
  { value: "15", label: "Shipper", moduleId: "3" },

  { value: "16", label: "Inventory Manager", moduleId: "4" },
  { value: "17", label: "Inbound Supervisor", moduleId: "4" },
  { value: "18", label: "Inventory Clerk", moduleId: "4" },

  { value: "19", label: "Admin", moduleId: "5" },
  { value: "20", label: "Warehouse Manager", moduleId: "5" },

  { value: "21", label: "Admin", moduleId: "1" },
  { value: "22", label: "Customer Service", moduleId: "1" },
  { value: "23", label: "Warehouse Manager", moduleId: "1" },
  { value: "24", label: "Inbound Manager", moduleId: "1" },
  { value: "25", label: "Inbound Supervisor", moduleId: "1" },
  { value: "26", label: "Receiver", moduleId: "1" },
  { value: "27", label: "Auditor", moduleId: "1" },

  { value: "28", label: "Admin", moduleId: "1" },
  { value: "29", label: "Customer Service", moduleId: "1" },
  { value: "30", label: "Warehouse Manager", moduleId: "1" },
  { value: "31", label: "Outbound Manager", moduleId: "1" },
  { value: "32", label: "Outbound Supervisor", moduleId: "1" },
  { value: "33", label: "Picker", moduleId: "1" },
  { value: "34", label: "Packer", moduleId: "1" },
  { value: "35", label: "Shipper", moduleId: "1" },

  { value: "36", label: "Inventory Manager", moduleId: "1" },
  { value: "37", label: "Inbound Supervisor", moduleId: "1" },
  { value: "38", label: "Inventory Clerk", moduleId: "1" },

  { value: "39", label: "Admin", moduleId: "1" },
  { value: "40", label: "Warehouse Manager", moduleId: "1" },
];


export const asnDate = [];
export const eta = [];
export const createASNSupplier = [{ value: "1", label: "Target" },{ value: "2", label: "Target2" }];
export const createASNWarehouse = [{ value: "1", label: "Warehouse 1" }];
export const createASNCarrierName = [{ value: "1", label: "Fedex Ground" }];
export const itemConditionList = [
  { value: "1", label: "Good", color: "green" },
  { value: "2", label: "Reserved", color: "black" },
  { value: "3", label: "QC Hold", color: "black" },
  { value: "4", label: "Damage", color: "black" },
  { value: "5", label: "Finished Goods", color: "black" },
];
export const unloadItemConditionList = [
  { value: "1", label: "Good", color: "green" },
  { value: "2", label: "Reserved", color: "black" },
  { value: "3", label: "QC Hold", color: "black" },
  { value: "4", label: "Damage", color: "black" },
  { value: "5", label: "Finished Goods", color: "black" },
];
export const asnUnloadItemConditionList = [
  { value: "1", label: "Carton", color: "black" },
  { value: "2", label: "Pallet", color: "black" },
  { value: "3", label: "Case", color: "black" }
];



export const stockTransferDropDownData = [
  {
    name: "By Item",
    link: "transfer-by-item",

  }
  ,
  {
    name: "By Location",
    link: "transfer-by-location",

  }
]

export const cycleCountDropDownData = [
  {
    name: "By Item",
    link: "by-item",

  }
  ,
  {
    name: "By Location",
    link: "by-location",

  }
]

export const assignUser = [
  { value: "1", label: "Sebastian" },
  { value: "2", label: "Samuel" },
  { value: "3", label: "Santiago" },
  { value: "4", label: "Silas" }
];

export const frequency = [
  { value: "1", label: "Daily" },
  { value: "2", label: "Weekly" },
  { value: "3", label: "Monthly" }
];

export const ends = [
  { value: true, labelName: "Never" },
  { value: false, labelName: "On" },
  { value: false, labelName: "After" },
];
export const days = ["S", "M", "T", "W", "T", "F", "S"];


export const assemblyPart = [
  { value: "1", label: "CH12133" },
  { value: "2", label: "CH12143" }
]

export const allocationDropDownData = [
  {
    name: "Create",
    link: "create",
  },
  {
    name: "Single",
    link: "single",
  },
  {
    name: "Multiple",
    link: "multiple",
  },
  {
    name: "All",
    link: "all",
  }
]